/**
 * mobile端检测
 * 1.user-agent表明是mobile端身份
 * 2.query中包含`mobile=1`或`mobile=true`的参数
 * @author luoying
 * @since 17/07/27
 *
 * @update VenDream 17/12/27
 */
import * as qs from './query-string';
/**
 * 根据UserAgent来检测是否是mobile端
 * @param {string} [ua] 可以外部传递指定的UserAgent
 * @returns {boolean}
 */
export function isMobileByUserAgent(ua) {
    if (!ua)
        ua = navigator.userAgent || navigator.vendor;
    const reg = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|wp7/i;
    return (ua && reg.test(ua)) || false;
}
/**
 * 根据查询参数来检测是否是mobile端
 * @param {string} [search] url查询参数
 * @returns {boolean}
 */
export function isMobileBySearch(search) {
    if (!search)
        search = window.location.search;
    let param = qs.parse(search).mobile;
    if (Array.isArray(param))
        param = param[0];
    return (param && [1, '1', 'true'].indexOf(param) >= 0) || false;
}
/**
 * mobile端检测
 * @param {boolean} [deep=true] deep参数表示当ua检查为非移动端时，是否继续检查search
 * @returns {boolean}
 */
export default function isMobile(deep = true, ua) {
    if (isMobileByUserAgent(ua))
        return true;
    if (deep)
        return isMobileBySearch();
    return false;
}
//# sourceMappingURL=is-mobile.js.map